import { render, staticRenderFns } from "./bodMeetings.vue?vue&type=template&id=265b237f&scoped=true&"
import script from "./bodMeetings.vue?vue&type=script&lang=js&"
export * from "./bodMeetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b237f",
  null
  
)

export default component.exports